<template>
  <div class="w-full">
    <div class="slides-header hidden md:block" />
    <div
      class="template-slides"
      :class="{'has-fixed-height': isPopupMode}"
    >
      <p class="mb-3 text-base-90 font-bold">
        Slides ({{ slides.length }})
      </p>
      <div
        class="template-slide-item"
        v-for="(item, index) in slides"
        :key="item.id"
        :class="{'show-option': checkShowOption(item)}"
      >
        <div class="template-slide-item-content" @click="handleSlideClick(item)">
          <div class="flex-grow">
            <h4 class="text-xs mb-1.5">
              {{ index + 1 }} - {{ getSlideType(item) }}
            </h4>
            <p class="text-title">
              {{ item.title }}
            </p>
          </div>
          <div class="option-thumbnail" v-if="item.image">
            <img
              :src="item.image.thumbnail"
              v-if="item.image"
              class="rounded max-h-16"
            >
          </div>
        </div>
        <div class="template-slide-options" v-if="checkShowOption(item)">
          <div v-if="item.type === 'pickAnswer' && item.slideType === 'typeAnswer'">
            <div
              class="template-option relative"
              v-for="(option, indexOption) in item.typeAnswerOptions"
              :key="indexOption"
            >
              <div class="pr-8">
                {{ option.title }}
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="template-option relative"
              v-for="(option, indexOption) in item.SlideOptions"
              :key="option.id"
            >
              <div class="pr-8">
                <b>{{ indexOption + 1 }}</b>. {{ option.title }}
                <span v-if="item.type === 'pickAnswer' && item.slideType === 'matchPairs'">
                  - {{ option.pairTitle }}
                </span>
              </div>

              <span
                v-if="option.correct && !isNotShowCorrectSlideOptions(item)"
                class="absolute right-0 w-6 text-center icon-correct"
                v-tooltip="'This is the correct answer'"
              >
                <aha-icon
                  name="circle-check"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  class="mb-0.5 text-green-50"
                />
              </span>
              <span
                v-if="!option.correct
                  && !isNotShowCorrectSlideOptions(item) && hasCorrectAnswer(item)"
                class="absolute right-0 w-6 text-center icon-correct"
                v-tooltip="'This is the incorrect answer'"
              >
                <aha-icon
                  name="incorrect"
                  viewBox="0 0 18 18"
                  width="16"
                  height="16"
                  class="mb-0.5 text-red-50"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus'
import Constant from '@/constant'

const SHOW_OPTIONS_TYPES = [
  'multipleChoice',
  'imageChoice',
  'scale',
  'pickAnswer',
  'spinnerWheel',
  'bulletPoints',
]
const NOT_SHOW_CORRECT_TYPES = [
  'scale',
  'spinnerWheel',
  'bulletPoints',
]

export default {
  components: {
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
    isPopupMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showOptionSlide: null,
      slideTypeList: [],
    }
  },
  mounted() {
    let slideTypesList = []
    Constant.allTypeSections.forEach((item) => {
      slideTypesList = slideTypesList.concat(item.slideTypes)
    })
    this.slideTypeList = slideTypesList
  },
  methods: {
    handleSlideClick(item) {
      if (this.showOptionSlide === item.id) {
        this.showOptionSlide = null
      } else {
        this.showOptionSlide = item.id
      }
      EventBus.$emit(Constant.Events.EVENT_CHANGE_SLIDE, item)
    },
    checkShowOption(item) {
      if (!this.showOptionSlide || item.id !== this.showOptionSlide) return false
      if (item.type === 'pickAnswer' && item.slideType === 'typeAnswer') {
        if (item.correctQuizTypeAnswer) return true
        return false
      }
      if (item.SlideOptions &&
        item.SlideOptions.length && SHOW_OPTIONS_TYPES.indexOf(item.type) > -1) {
        return true
      }
      return false
    },
    isNotShowCorrectSlideOptions(slide) {
      if (slide.type === 'pickAnswer' && (slide.slideType === 'matchPairs' || slide.slideType === 'correctOrder')) {
        return true
      }
      return NOT_SHOW_CORRECT_TYPES.indexOf(slide.type) > -1
    },
    getSlideType(slide) {
      if (slide.type === 'pickAnswer') {
        const indexPickAnswer = this.slideTypeList.findIndex((item) => item.type === slide.type &&
          item.slideType === slide.slideType)
        if (indexPickAnswer !== -1) {
          return this.slideTypeList[indexPickAnswer].name
        }
      } else {
        const index = this.slideTypeList.findIndex((item) => item.type === slide.type)
        if (index !== -1) {
          return this.slideTypeList[index].name
        }
      }
    },
    hasCorrectAnswer(item) {
      return item.SlideOptions.some((slideOption) => slideOption.correct)
    },
  },
}
</script>

<style lang="scss" scoped>
.slides-header {
  width: 100%;
  height: 40px;
  background: #F0F4FA;
}
.template-slides {
  @apply overflow-auto w-full;
  background: #F0F4FA;
  padding: 20px;
  padding-top: 0px;

  &.has-fixed-height {
    height: calc(100vh - 200px);
    @media screen and (max-width: 767px) {
      height: calc(100vh - 400px);
    }
  }

  @media screen and (max-width: 767px) {
    padding-top: 20px;
  }
}

.template-slide-item {
  @apply mb-3 rounded p-3 cursor-pointer shadow-card;
  transition: 0.2s ease all;
  background: #FFFFFF;

  &:hover {
    @apply border-primary-90;
    box-shadow: 0px 25px 20px -20px rgba(0, 0, 0, .2);
  }

  .template-slide-item-content {
    @apply flex flex-row h-16;
  }

  &.show-option {
    .template-slide-item-content {
      height: auto;
    }
    .text-title {
      display: block;
    }
  }
}

.template-slide-options {
  @apply border-t border-base-40 mt-6;
}

.text-title {
  font-size: 16px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
}
.template-option {
  cursor: default;
  @apply border-b border-base-40 pt-3 pb-3;

  &:last-child {
    border-bottom: 0;
  }
}

.icon-correct {
  top: 50%;
  margin-top: -11px;
}

.option-thumbnail {
  @apply w-28 float-right flex justify-end;
  flex-shrink: 0;
}
</style>
